import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-options-click-meeting',
  templateUrl: './options-click-meeting.component.html',
  styleUrls: ['./options-click-meeting.component.scss'],
})
export class OptionsClickMeetingComponent implements OnInit {
  item: any;
  item2: any;

  constructor(
    private popoverController: PopoverController
  ) { }

  ngOnInit() { }

  certificates() {
    this.popoverController.dismiss({ action: 'certificates' });
  }

  confirmations() {
    this.popoverController.dismiss({ action: 'confirmations' });
  }

  getChats() {
    this.popoverController.dismiss({ action: 'getChats' });
  }

  triggerInputFile() {
    this.popoverController.dismiss({ action: 'triggerInputFile' });
  }

  assistance() {
    this.popoverController.dismiss({ action: 'assistance' });
  }

  reports() {
    this.popoverController.dismiss({ action: 'reports' });
  }
}
